export interface Application {
    id?: number;
    name: string;
    description?: string;
    documentation: string;
    code: string;
}
